import React, { useEffect, useState } from "react";
import { apiCallSPPost } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearch,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import { SearchFilterModel } from "../../Reports/Component/SearchFilterModel";
import TableButtonClick from "src/views/common/Table/TableButtonClick";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import CustomeModalPopup from "src/views/common/CustomeModalPopup";
import { CCol, CInput, CLabel, CRow } from "@coreui/react";

const ChequeClearingList = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(true); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(true); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  const [paymentId, setPaymentId] = useState();
  const [lotPaymentId, setLotpPaymentId] = useState();
  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  // adding button loader
  //const [CPopUpButtonLoader, SetCPopUpButtonLodaer] = useState(false);

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);

  const [showModal, setShowModal] = useState(false);

  // Page  API URL manage
  const ReportListUrl = `Cheque/Clearing/EMDSD15per/List`;

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tenderNo: search.tenderNo.trim(),
      circle_id: authenticated.circle_id,
      district_id: authenticated.district,
      lotNo: search.lotNo.trim(),
      date: search.date,
    });
  };

  const StatusUpdateModel = {
    clearing_date: "",
  };
  // Search Model
  const [statusUpdate, setStatusUpdate] = useState(StatusUpdateModel);

  useEffect(() => {
    setloading(true);
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getReportList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();
      console.log("dddd:", getdata());
      await apiCallSPPost(ReportListUrl, getdata(), []).then((res) => {
        console.log("getReportList res", ReportListUrl, res);
        if (res.success && res.totalRecord > 0) {
          setUsersData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingManage(pageCount);
          } else {
            paggingManage(parseInt(res.totalRecord) || 0);
          }
        } else {
          setUsersData([]);
          paggingManage(0, false);
          //alert(res.message);
        }
        setloading(false);
      });
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  const handleApproveRejectCOfirmationOpen = async (
    PopupId,
    paymentIdOfLot,
    getLotPaymentId,
    message
  ) => {
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(message);
    setCPopUpId(PopupId);
    setPaymentId(paymentIdOfLot);
    setLotpPaymentId(getLotPaymentId);
  };

  const SubmitConfirmationPopUpResponse = async () => {
    //SetCPopUpButtonLodaer(true);
    setCPopUpIndex(-1);

    //alert("ca;;;" + CPopUpId + "|" + lotPaymentId + "|" + CPopUpBodyText);
    console.log(
      "ddatga",
      CPopUpId,
      lotPaymentId,
      CPopUpBodyText,
      CPopUpDisplayConfirmationModal
    );
    if (CPopUpId === 1) {
      await ChequeClearingStatusUpdate(CPopUpId, paymentId, lotPaymentId);
    } else if (CPopUpId === 2) {
      setShowModal(true);
      //SetCPopUpButtonLodaer(true);
      setCPopUpIndex(-1);
      handleConfirmationPopUpModalClose();
      setStatusUpdate({ ...statusUpdate, ...StatusUpdateModel });
    }
  };

  const ChequeClearingStatusUpdate = async (
    ChequeClearingStatusId,
    PaymentId,
    LotPaymentId
  ) => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();
      let getData = "";

      let url = "";
      if (ChequeClearingStatusId === 1) {
        getData = JSON.stringify({
          payment_id: Number(PaymentId),
          user_id: authenticated.userId,
          lot_payment_id: LotPaymentId,
        });
        url = "Cheque/Clearing/EMDSD15per/Status_Pending";
      } else if (ChequeClearingStatusId === 2) {
        getData = JSON.stringify({
          payment_id: Number(paymentId),
          user_id: authenticated.userId,
          clearing_date: statusUpdate.clearing_date,
          lot_payment_id: LotPaymentId,
        });
        url = "Cheque/Clearing/EMDSD15per/Status_Update";
      }

      await apiCallSPPost(url, getData, 0).then((res) => {
        if (res.success) {
          alert(res.message);
          getReportList();

          if (ChequeClearingStatusId === 1) {
            //SetCPopUpButtonLodaer(false);
            handleConfirmationPopUpModalClose();
          } else {
            setShowModal(false);
            setStatusUpdate({ ...statusUpdate, ...StatusUpdateModel });
          }
        } else {
          alert(res.message);
          if (ChequeClearingStatusId === 1) {
            //SetCPopUpButtonLodaer(false);
            handleConfirmationPopUpModalClose();
          } else {
            setShowModal(false);
            setStatusUpdate({ ...statusUpdate, ...StatusUpdateModel });
          }
        }
        setCPopUpBodyText("");
        setCPopUpId("");
        setPaymentId("");
        setLotpPaymentId("");
        setloading(false);
      });
    }
  };
  const scopedSlotsCommon = {
    chequeClearingStatusValue: (item) => {
      return (
        <td className="py-2">
          <span>
            {item.chequeClearingStatus === 0 && "Not Process"}
            {item.chequeClearingStatus === 1 && "In-Process"}
            {item.chequeClearingStatus === 2 && "Updated - Paid"}
          </span>
        </td>
      );
    },
    agreementApprovedByCCF: (item) => {
      return (
        <td className="py-2">
          <span>{item.isCCFAgreementApproved === true ? "Yes" : "No"}</span>
        </td>
      );
    },
    actionSet: (item) => {
      //console.log("scopedSlotsCommon", item, index);
      return (
        <>
          {item.isCCFAgreementApproved === true ? (
            <>
              {item.chequeClearingStatus === 0 && (
                <TableButtonClick
                  buttonName={"Clearing Cheque"}
                  isDisplayAllow={
                    item.chequeClearingStatus === 0 ? true : false
                  }
                  isButtonLoader={true}
                  onClick={() =>
                    handleApproveRejectCOfirmationOpen(
                      1,
                      item.paymentId,
                      item.lotPaymentId,
                      `Are you sure you want the 'Cheque clearing' process start?`
                    )
                  }
                />
              )}
              {item.chequeClearingStatus === 1 && (
                <TableButtonClick
                  color={"primary"}
                  buttonName={"Clearing Update"}
                  isDisplayAllow={
                    item.chequeClearingStatus === 1 ? true : false
                  }
                  isButtonLoader={true}
                  onClick={() =>
                    handleApproveRejectCOfirmationOpen(
                      2,
                      item.paymentId,
                      item.lotPaymentId,
                      `Are you sure you want the 'Cheque clearing' process updated?`
                    )
                  }
                />
              )}

              {item.chequeClearingStatus === 2 && (
                <td className="py-2">
                  <span></span>
                </td>
              )}
            </>
          ) : (
            <td className="py-2">
              <span></span>
            </td>
          )}
        </>
      );
    },
  };

  const handleClose = (event, reason) => {
    console.log("reason : ", reason);
    if (reason === "escapeKeyDown") {
      console.log("ddd", "escapeKeyDown");
    }
    if (reason === "backdropClick") {
      console.log("ddd", "backdropClick");
    }
    if (reason !== "backdropClick") {
      hideModal();
    }
  };
  const hideModal = () => setShowModal(false);
  // Search Model Value Update Manage
  const updateEntry = (e, name = "", value = "") => {
    updateSearchStatus(setStatusUpdate, statusUpdate, e, name, value);
  };
  const SubmitConfirmation = async (e) => {
    e.preventDefault();
    //props.SetCPopUpButtonLodaer(true);
    setCPopUpIndex(-1);

    await ChequeClearingStatusUpdate(2, paymentId, lotPaymentId);
  };
  //Search Filter Manage ( UI also)
  const additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isCompanyNameDisplay={false}
      //isEmailAddressDisplay={true}
      isLotNumberDisplay={true}
    />
  );
  const fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },

    {
      key: "lotNo",
      _style: { width: "6.5%" },
      label: "Lot No.",
    },
    {
      key: "tenderNo",
      _style: { width: "7.5%" },
      label: "Tender No",
    },
    {
      key: "companyName",
      _style: { width: "17.5%" },
      label: "Company Name",
    },
    {
      key: "chequeNo",
      _style: { width: "7.5%" },
      label: "Cheque No",
    },
    {
      key: "amount",
      _style: { width: "7.5%" },
      label: "Amount",
    },
    {
      key: "insertDateTime",
      _style: { width: "7.5%" },
      label: "Cheque Insert Date",
    },

    {
      key: "chequeClearingDate",
      _style: { width: "7.5%" },
      label: "Cheque Clearing Date",
    },

    {
      key: "chequeReplacementLastDate",
      _style: { width: "15%" },
      label: "Cheque Replacement Last Date",
    },
    // {
    //   key: "secondExtensionDateTime",
    //   _style: { width: "15%" },
    //   label: "Second Extension Date Time",
    // },
    {
      key: "chequeClearingStatusValue",
      _style: { width: "10%" },
      label: "Clearing Status",
    },
    {
      key: "agreementApprovedByCCF",
      _style: { width: "5%" },
      label: "Agreement Approved By CCF",
    },
    {
      key: "actionSet",
      _style: { width: "15%" },
      label: "Action",
    },
  ];
  return (
    <>
      <CommonList
        items={usersData}
        fields={fields}
        scopedSlots={scopedSlotsCommon}
        listName="Cheque Clearing"
        loading={loading}
        additional={additional}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        id="userid"
      />

      <ConfirmationPopup
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={CPopUpIndex}
        ModalBody={CPopUpBodyText}
        //ModalBody={"Are you sure you want to Reverse Entry?"}
        //ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        // ButtonLoader={CPopUpButtonLoader}
      />

      <CustomeModalPopup
        onOpen={showModal}
        onClose={handleClose}
        onSubmitButton={SubmitConfirmation}
        onCloseButton={handleClose}
        isSubmitBtnDisabled={false}
        isFromSubmit={true}
        popupWith={520}
        btnCColstyle={{ textAlign: "right" }}
        body={
          <>
            <CRow>
              <CCol>
                <CLabel>Cheque Clearing Update</CLabel>
              </CCol>
            </CRow>
            <hr />
            <CRow className="mb-3">
              <CCol>
                <CLabel>Clearing Update Date * :</CLabel>
                <CInput
                  required
                  type="date"
                  placeholder=""
                  id={"clearing_date"}
                  name={"clearing_date"}
                  value={statusUpdate.clearing_date}
                  onChange={updateEntry}
                  max={new Date().toISOString().split("T")[0]}
                />
              </CCol>
            </CRow>
          </>
        }
      />
    </>
  );
};

export default ChequeClearingList;
